import { render, staticRenderFns } from "./ApplicationFormPage.vue?vue&type=template&id=000913fa&scoped=true&"
import script from "./ApplicationFormPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationFormPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFormPage.vue?vue&type=style&index=0&id=000913fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000913fa",
  null
  
)

export default component.exports